/**
 * @generated SignedSource<<a5c9aadba68216ff6ad56cf04f4908b2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AddScreenAssignDashboardPromptQuery$variables = Record<PropertyKey, never>;
export type AddScreenAssignDashboardPromptQuery$data = {
  readonly store: {
    readonly dashboards: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
    }>;
  };
};
export type AddScreenAssignDashboardPromptQuery = {
  response: AddScreenAssignDashboardPromptQuery$data;
  variables: AddScreenAssignDashboardPromptQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "Dashboard",
  "kind": "LinkedField",
  "name": "dashboards",
  "plural": true,
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AddScreenAssignDashboardPromptQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AddScreenAssignDashboardPromptQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6c0683a8aa1d764fab7a27c9315ed54e",
    "id": null,
    "metadata": {},
    "name": "AddScreenAssignDashboardPromptQuery",
    "operationKind": "query",
    "text": "query AddScreenAssignDashboardPromptQuery {\n  store {\n    dashboards {\n      id\n      name\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "fcdb31bfe99fa54a2e0e51b49461cf12";

export default node;
